// Initialize userSelection object (if not already defined)
if (typeof userSelection === "undefined") {
  var userSelection = {
    frameType: "Black", // Default values
    frameSize: "120x80",
    frameKey: "Frame_Black_120_4", // Store the frame key
    frameVariantId: null, // Will be set using getVariantId
    texture: "Oak", // Default texture
    selectedMonitorBracket: "", // Default: No monitor bracket
    includeKabelgoot: false, // Default: No Kabelgoot
  };
}

// Variant ID mapping (include both frame and texture)
const variantMapping = {
  // Oak variants
  "Frame_Black_120_4_Oak": "49293832028497",
  "Frame_Black_140_0_Oak": "49293832290641",
  "Frame_Black_180_5_Oak": "49293832356177",
  "Frame_White_120_11_Oak": "49293832421713",
  "Frame_White_140_10_Oak": "49293832520017",
  "Frame_White_180_9_Oak": "49293832585553",

  // White Oak variants
  "Frame_Black_120_4_White Oak": "49293832257873",
  "Frame_Black_140_0_White Oak": "49293832323409",
  "Frame_Black_180_5_White Oak": "49293832388945",
  "Frame_White_120_11_White Oak": "492938324872495",
  "Frame_White_140_10_White Oak": "49293832552785",
  "Frame_White_180_9_White Oak": "49293832618321",

  // Monitor Brackets (existing)
  "Monitor_Bracket_FM-2": "50367644926289",
  "Monitor_Bracket_FM-1": "50452896678225",
  "Monitor_Bracket_SQ-2": "50452901200209",
  
  // Monitor Brackets (new, updated nodes)
  "Monitor_Bracket_Monitor_bracket_fm1_18": "50452896678225",
  "Monitor_Bracket_DXM-002_19": "50643150537041",
  "Monitor_Bracket_DXM-003_20": "50643153060177",
  "Monitor_Bracket_DXM-004_21": "50643159253329",
  "Monitor_Bracket_DXM-001_22": "50643167740241",
  "Monitor_Bracket_SH-X6_23": "50643170099537",
  "Monitor_Bracket_SH-X7_25": "50643172131153",
  "Monitor_Bracket_SH-AMSP-02_24": "50643174621521",

  // Kabelgoot
  "Kabelgoot": "50452855095633",
};

// Function to get Variant ID
function getVariantId(frameKey, texture) {
  const variantKey = `${frameKey}_${texture}`;
  console.log(`Getting variant ID for: ${variantKey}`);
  return variantMapping[variantKey];
}

// Event listeners to update userSelection for frame and texture
document.getElementById("blackFrameDropdown").addEventListener("change", (e) => {
  const selectedBlackFrame = e.target.value;
  userSelection.frameType = "Black";
  userSelection.frameSize = selectedBlackFrame.includes("120")
    ? "120x80"
    : selectedBlackFrame.includes("140")
    ? "140x80"
    : "180x80";
  userSelection.frameKey = selectedBlackFrame;
  userSelection.frameVariantId = getVariantId(userSelection.frameKey, userSelection.texture);
  console.log(`Updated frame selection: ${JSON.stringify(userSelection)}`);
});

document.getElementById("whiteFrameDropdown").addEventListener("change", (e) => {
  const selectedWhiteFrame = e.target.value;
  userSelection.frameType = "White";
  userSelection.frameSize = selectedWhiteFrame.includes("120")
    ? "120x80"
    : selectedWhiteFrame.includes("140")
    ? "140x80"
    : "180x80";
  userSelection.frameKey = selectedWhiteFrame;
  userSelection.frameVariantId = getVariantId(userSelection.frameKey, userSelection.texture);
  console.log(`Updated frame selection: ${JSON.stringify(userSelection)}`);
});

document.getElementById("oakButton").addEventListener("click", () => {
  userSelection.texture = "Oak";
  userSelection.frameVariantId = getVariantId(userSelection.frameKey, userSelection.texture);
  console.log(`Texture changed to Oak: ${JSON.stringify(userSelection)}`);
});

document.getElementById("whiteOakButton").addEventListener("click", () => {
  userSelection.texture = "White Oak";
  userSelection.frameVariantId = getVariantId(userSelection.frameKey, userSelection.texture);
  console.log(`Texture changed to White Oak: ${JSON.stringify(userSelection)}`);
});

// Note: The monitor bracket selection is now handled via a custom dropdown,
// which updates userSelection.selectedMonitorBracket directly.

// Kabelgoot toggle
document.getElementById("cableTrayCheckbox").addEventListener("change", (e) => {
  userSelection.includeKabelgoot = e.target.checked;
  console.log(`Kabelgoot Included: ${e.target.checked}`);
});

// Add to Cart button logic with enhanced error handling for out-of-stock items
document.getElementById("add-to-cart-button").addEventListener("click", async function () {
  if (!userSelection.frameVariantId) {
    alert("Selecteer een frame en ga door met bestellen.");
    return;
  }

  const quantityInput = document.getElementById("quantityInput");
  const quantity = parseInt(quantityInput.value);

  if (isNaN(quantity) || quantity < 1) {
    alert("Please enter a valid quantity.");
    return;
  }

  const items = [
    {
      id: userSelection.frameVariantId,
      quantity: quantity,
    },
  ];

  // Add monitor bracket if selected
  if (userSelection.selectedMonitorBracket) {
    const monitorBracketKey = `Monitor_Bracket_${userSelection.selectedMonitorBracket}`;
    if (variantMapping[monitorBracketKey]) {
      items.push({
        id: variantMapping[monitorBracketKey],
        quantity: 1,
      });
    } else {
      console.warn(`Monitor bracket key "${monitorBracketKey}" not found in variantMapping.`);
    }
  }

  // Add Kabelgoot if selected
  if (userSelection.includeKabelgoot) {
    items.push({ id: variantMapping["Kabelgoot"], quantity: 1 });
  }

  console.log("Adding to cart:", items);

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });

    // If the response is not OK, parse the error details
    if (!response.ok) {
      const errorData = await response.json();
      // Check if the error message indicates an out-of-stock product
      if (
        errorData &&
        errorData.description &&
        errorData.description.toLowerCase().includes("sold out")
      ) {
        alert("Een van de geselecteerde producten is niet op voorraad. Kies een ander product.");
      } else {
        throw new Error("Error adding items to cart");
      }
      return;
    }

    window.location.href = "/cart";
  } catch (error) {
    console.error("Error adding to cart:", error);
    alert("Er is een fout opgetreden bij het toevoegen van de items aan de winkelwagen.");
  }
});

// Initialize the default cart setup
console.log("Cart setup initialized.");
